import Vue from 'vue'
import VueResource from 'vue-resource'
import config from '@/config'

Vue.use(VueResource)

Vue.http.options.emulateJSON = true

class DataService {
  constructor() {
    this.apiPath = config.apiPath
  }

  // Our server request to Wordpres
  getData(params) {
    return Vue.http
      .post(this.apiPath, params)
      .then(response => response.data)
  }
}

export default new DataService()
